<template>
  <div class="content">
    <div class="row">
      <div class="col-md-12">
        <div class="box box-primary">
          <div class="box-header with-border">
            <h3 class="box-title">生产条码箱码记录</h3>
            <div class="box-tools pull-right">
              <build @finish="finish">生产条码</build>
            </div>
          </div>
          <div class="box-body no-padding">
            <div style="padding-top: 20px;padding-left: 20px;">
              <el-form :inline="true">
                <el-form-item label="产品名称">
                  <el-input v-model="query.name" placeholder="请输入" clearable></el-input>
                </el-form-item>
                <el-form-item label="存货编码">
                  <el-input v-model="query.model_code" placeholder="请输入" clearable></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="querySelect">查询</el-button>
                </el-form-item>
              </el-form>
            </div>

            <el-table
                :data="list"
                border
                v-loading="listLoading"
                style="width: 100%"
            >
              <el-table-column prop="build_time" label="时间" width="160">
              </el-table-column>
              <el-table-column prop="name" label="产品">
              </el-table-column>
              <el-table-column prop="model_code" label="存货编码">
              </el-table-column>
              <el-table-column prop="batch" label="批次" width="200">
              </el-table-column>
              <el-table-column prop="build_num" label="生产数量" width="100">
              </el-table-column>
              <el-table-column prop="build_box_num" label="生产箱数" width="100">
              </el-table-column>
              <el-table-column prop="box_size" label="每箱数量" width="100">
              </el-table-column>
              <el-table-column label="操作" width="220">
                <template slot-scope="scope">
                  <div style="display: flex;align-items: center;">
                    <bar-code-detail :barcode="scope.row.entity">
                      条码信息
                    </bar-code-detail>
                    <div style="width: 10px;height: 10px;"></div>
                    <box-code-detail :boxcode="scope.row.box">
                      箱码信息
                    </box-code-detail>
                    <div style="width: 10px;height: 10px;"></div>
                    <a :href="scope.row.excel_url" target="_blank">
                      <el-button type="text" size="small">
                        下载
                      </el-button>
                    </a>
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <div style="padding: 10px">
              <el-pagination
                  background
                  layout="total, prev, pager, next"
                  :total="total"
                  :page-size="query.size"
                  :current-page="query.page"
                  @current-change="pageChange"
              >
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import {mapActions, mapState} from "vuex";
import qs from "qs";

import BarCodeDetail from "./BarCodeDetail.vue";
import BoxCodeDetail from "./BoxCodeDetail.vue";
import Build from "./Build.vue";

export default {
  components: {
    BarCodeDetail,
    BoxCodeDetail,
    Build
  },
  data() {
    return {
      params: {},
      query: {
        model_code: '',
        name: '',
        page: 1,
        size: 10,
      },
      list: [],
      total: 0,
      listLoading: false,
      seeBarCodeStatus: false,
      seeBoxCodeStatus: false,
    };
  },
  computed: mapState({
    config: (state) => state.config,
  }),
  mounted() {
    const _this = this;
    _this.query = Object.assign(_this.query, _this.$route.query);
    _this.query.page = parseInt(_this.query.page);
    _this.query.size = parseInt(_this.query.size);
    _this.listLoading = true;
    _this.authInit(_this).then(() => {
      _this.loadList();
    });
  },
  methods: {
    ...mapActions(["authInit"]),
    updateUrl() {
      const _this = this;
      const url = _this.$route.path + "?" + qs.stringify(_this.query);
      _this.$router.replace({path: url});
    },
    // 获取列表
    loadList() {
      const _this = this;
      _this.$api.barcodeBuildList(_this.query)
          .then(res => {
            _this.listLoading = false;
            _this.list = res.list;
            _this.total = res.total;
            _this.updateUrl();
          })
          .catch(err => {
            _this.listLoading = false;
            _this.$message.error(err.msg);
          })
    },
    // 分页
    pageChange(page) {
      const _this = this;
      _this.listLoading = true;
      _this.query.page = parseInt(page);
      _this.loadList();
    },
    // 筛选
    querySelect() {
      const _this = this;
      _this.query.page = 1;
      _this.listLoading = true;
      _this.loadList();
    },
    finish() {
      const _this = this;
      _this.query.page = 1;
      _this.listLoading = true;
      _this.loadList();
    },
  },
};
</script>

<style scoped>
.custom-tree-node {
  display: flex;
  justify-content: space-between;
}

.custom-tree-node-name {
  width: 400px;
}
</style>